import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../motion";
import { Eyebrow, GhostButton } from "../CTA";
import { MACHINES } from "../../lib/site";

const MachineCard = ({ m, large = false }) => (
  <Link
    to="/machinery"
    data-testid={`machine-card-${m.slug}`}
    className={`group relative flex flex-col overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] transition-colors duration-300 hover:border-brand-soft/40 ${large ? "lg:row-span-2" : ""}`}
  >
    <div className={`relative overflow-hidden ${large ? "aspect-[4/5]" : "aspect-[4/3]"} bg-gradient-to-b from-white/5 to-transparent`}>
      <div className="spotlight absolute inset-0 z-10 opacity-70 transition-opacity duration-500 group-hover:opacity-100" />
      <img
        src={m.image}
        alt={m.name}
        loading="lazy"
        decoding="async"
        className={`relative z-0 h-full w-full object-contain p-6 transition-transform duration-700 group-hover:scale-105`}
      />
      <div className="absolute left-4 top-4 z-20 rounded-full bg-brand px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white">
        {m.make}
      </div>
    </div>
    <div className="flex items-start justify-between gap-3 p-6">
      <div>
        <h3 className="font-display text-xl font-semibold text-white">{m.name}</h3>
        <p className="mt-1 text-sm text-white/50">{m.tagline}</p>
      </div>
      <span className="mt-1 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
        <ArrowUpRight className="h-4 w-4" />
      </span>
    </div>
  </Link>
);

const MachineryShowcase = () => {
  const preview = MACHINES.slice(0, 5);
  return (
    <section className="relative overflow-hidden bg-ink py-24 grain sm:py-32" data-testid="machinery-showcase">
      <div className="blueprint-grid absolute inset-0 opacity-40" />
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <Eyebrow dark>Manufacturing Facilities</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-medium tracking-tight text-white sm:text-5xl">
              World-class machinery.
              <br />
              <span className="text-steel">Built for precision at scale.</span>
            </h2>
          </div>
          <GhostButton to="/machinery" dark testId="machinery-viewall-btn">View All Machinery</GhostButton>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <Reveal className="lg:row-span-2"><MachineCard m={preview[0]} large /></Reveal>
          {preview.slice(1).map((m, i) => (
            <Reveal key={m.slug} delay={i * 0.06}><MachineCard m={m} /></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MachineryShowcase;
